import React, { useMemo } from "react";
import PitchSvg from "../PitchSvg";

const VIEW_BOX = "8.22 42.75 298.37 289.59";
const CENTER_X = 157.405;
const CENTER_Y = 187.545;
const MAP_TEXT_COLOR = "#ff4d4f";
const TEAM_TEXT_COLOR = "#111111";
const CAPTION_COLOR = "#f3b562";

const WindDirectionPreview = ({ angle, homeTeam }) => {
  const normalizedAngle = useMemo(() => {
    const n = Number(angle);
    if (Number.isNaN(n)) return 0;
    return ((n % 360) + 360) % 360;
  }, [angle]);

  return (
    <div className="mb-3 text-start">
      <div
        className="small mb-2"
        style={{ color: CAPTION_COLOR, fontWeight: 600 }}
      >
        Wind Direction for Home Team Playing Up in 1st Half
      </div>
      <div
        style={{
          position: "relative",
          width: 180,
          margin: "0 auto 0 0",
        }}
      >
        <PitchSvg style={{ width: "100%", display: "block" }} />
        <svg
          viewBox={VIEW_BOX}
          preserveAspectRatio="xMidYMid meet"
          style={{
            position: "absolute",
            inset: 0,
            width: "100%",
            height: "100%",
            pointerEvents: "none",
          }}
        >
          <defs>
            <marker
              id="wind-arrow-head"
              markerWidth="6"
              markerHeight="6"
              refX="5.5"
              refY="3"
              orient="auto"
            >
              <path d="M0,0 L6,3 L0,6 Z" fill="#ff2f2f" />
            </marker>
          </defs>
          <g transform={`rotate(${normalizedAngle} ${CENTER_X} ${CENTER_Y})`}>
            <line
              x1={CENTER_X}
              y1={CENTER_Y + 16}
              x2={CENTER_X}
              y2={CENTER_Y - 64}
              stroke="#ff2f2f"
              strokeWidth="4"
              markerEnd="url(#wind-arrow-head)"
              strokeLinecap="butt"
            />
          </g>
        </svg>
        <div
          style={{
            position: "absolute",
            left: 8,
            top: 8,
            fontWeight: 700,
            color: MAP_TEXT_COLOR,
          }}
        >
          Wind Angle: {normalizedAngle}&deg;
        </div>
        <div
          style={{
            position: "absolute",
            left: "50%",
            bottom: 12,
            transform: "translateX(-50%)",
            fontWeight: 700,
            color: TEAM_TEXT_COLOR,
            textAlign: "center",
            maxWidth: "80%",
            lineHeight: 1.1,
          }}
        >
          {homeTeam || "Home Team"}
        </div>
      </div>
    </div>
  );
};

export default WindDirectionPreview;
